import React, { ReactElement } from 'react';

import { Endpoint, Route } from '@philips-emr/hpms-stipulator-commons';
import FilterService from '@philips-emr/hpms-stipulator-commons/lib/services/filter-service';
import HpmsCustomCardAPI from '@philips-emr/hpms-stipulator-components/lib/api/hpms-custom-card-api';
import { DeckAPI, DeckValue, Image, Stamp, StampIcon, Token } from '@philips-emr/tws-components';
import { Color, Type } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount, OnSelectItem, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { MensagensAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import './mensagem-controller.css';

export enum AnexoStatus {
  SIM = 'S',
  NAO = 'N',
}

export enum MensagemStatus {
  SIM = 'S',
  NAO = 'N',
}

export enum ImportanteStatus {
  SIM = 'S',
  NAO = 'N',
}

export interface Mensagem {
  nrSeqComunicado: string;
  dsTitulo: string;
  dsTexto: string;
  ieLeitura: MensagemStatus;
  ieTipoComunicado: string;
  dtLiberacao: string;
  ieAnexo: string;
  ieImportante: ImportanteStatus;
  iePrioridade: string;
  descricao: string;
  ieNaoLida: string;
  qtNaoLida: string;
}

export interface Anexo {
  nmAnexo: string,
  nrSeqAnexo: number,
}

@Controller({ fragment: FragmentNames.MENSAGENS })
export default class MensagemController extends BaseController {

  @OnMount(Aliases.FILTER_CONSULTA_MENSAGENS)
  onFilterMount(event: MountEvent): void {
    FilterService.restoreFilterState(event);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA_MENSAGENS)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnMount(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onMountHpmsCustomCardMensagens({ target }: MountEvent): void {
    const api = target as HpmsCustomCardAPI;
    const data = api.state;
    const { ieLeitura } = data as unknown as { ieLeitura: string };
    if (ieLeitura !== MensagemStatus.SIM) {
      api.setBackground('hsl(var(--color-5))');
    }
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_FIELD_STATUS)
  onDynamicContentRenderHpmsMensagemCard({ data, render }: RenderEvent): void {
    const { ieImportante, ieAnexo } = data as { ieImportante: string, ieAnexo: string };
    const elements: ReactElement[] = [];
    
    if (ieAnexo === AnexoStatus.SIM) {
      elements.push(<Image alt="" src="/static/assets/DLS_Attachment_32.svg" className="icon-attachment" />);
    }

    if (ieImportante === ImportanteStatus.SIM) {
      elements.push(<Stamp icon={StampIcon.WARNING} color={Color.SAFETY_ORANGE} label={''} />);
    }

    render(() => <div className="dynamic-content">
      {...elements}
    </div>);
  }

  @OnDynamicContentRender(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onDynamicContentRenderMensagens({ data, render }: RenderEvent): void {
    const { ieLeitura } = data as { ieLeitura: string};
    let leitura: ReactElement = <></>;

    if (ieLeitura !== MensagemStatus.SIM) {
      leitura =
      <div className="u-token-bullet">
        <Token type={Type.NOTICE} value={''} />
      </div>;
    }

    render(() => <>
      { leitura }
    </>);
  }

  @OnSelectItem(Aliases.DECK_MENSAGENS)
  onSelectItemDeckMensagens({ item, target }: SelectItemEvent<DeckValue>): void {
    const api = target as DeckAPI;
    api.unselectAll();

    const { nrSeqComunicado, ieLeitura } = item as unknown as Mensagem;

    if (ieLeitura != MensagemStatus.SIM) {
      void HttpService.post(Endpoint.POST.LEITURA_MENSAGEM, { nrSeqComunicado });
    }
    this.historyService.push(Route.MENSAGEM_DETALHES, { nrSeqComunicado });
  }

}
